<template>
  <div class='qbo-sync-status' v-if='should_show'>
    <span :class="[ 'qbo-dot', `is-${ state.key }` ]" />
    <span class='qbo-label'>QuickBooks: {{ state.label }}</span>
    <span class='qbo-detail'>{{ state.detail }}</span>
    <a
      v-if='state.invoice_url'
      class='qbo-link'
      :href='state.invoice_url'
      target='_blank'
      rel='noopener noreferrer'
      >View invoice</a>
    <b-button
      v-if='can_retry'
      class='qbo-retry'
      size='sm'
      variant='outline-danger'
      :disabled='retrying'
      @click='retry'
      >{{ retrying ? 'Retrying…' : 'Retry QuickBooks' }}</b-button>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import axios from '@/axios';
import _ from 'lodash';

export default {
  name: 'QboSyncStatus',
  data () {
    return {
      retrying: false,
    };
  },
  computed: {

    ...mapState( 'order_details', [
      'order'
    ]),

    // null whenever the QuickBooks plugin is inactive, which hides the whole row
    state () {
      return this.order?.qbo_sync ?? null;
    },

    // The idle state only explains why an invoice does not exist before completion.
    // Keep meaningful QuickBooks states visible regardless of the order status.
    should_show () {
      return this.state && ( this.state.key !== 'idle' || this.order?.status === 'wc-completed' );
    },

    can_retry () {
      return this.state?.key === 'attention' && Boolean( this.state.error );
    },

  },
  methods: {
    async retry () {
      if ( this.retrying || !this.order?.id ) {
        return;
      }

      this.retrying = true;

      try {
        const response = await axios.post( `orders/${ this.order.id }/qbo-retry` );
        this.$store.commit( 'order_details/set_order_prop', {
          prop: 'qbo_sync',
          value: response.data.qbo_sync,
        });
        this.$jjToast({
          type: 'success',
          title: 'QuickBooks synced',
          content: 'The invoice was sent to QuickBooks.',
        });
      } catch ( error ) {
        const qbo_sync = _.get( error, 'response.data.data.qbo_sync' );
        if ( qbo_sync ) {
          this.$store.commit( 'order_details/set_order_prop', {
            prop: 'qbo_sync',
            value: qbo_sync,
          });
        }
        this.$jjToast({
          type: 'error',
          title: 'QuickBooks retry failed',
          content: _.get( error, 'response.data.message', 'The invoice could not be sent. Please try again.' ),
        });
      } finally {
        this.retrying = false;
      }
    },
  },
}
</script>

<style lang='scss' scoped>
.qbo-sync-status {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 0.5rem;
  font-size: 0.875rem;
}
.qbo-dot {
  display: inline-block;
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background: #c3c4c7;
  box-shadow: inset 0 0 0 1px rgba( 0, 0, 0, 0.14 );
  flex: 0 0 auto;
}
.qbo-dot.is-synced { background: #46b450; }
.qbo-dot.is-queued { background: #dba617; }
.qbo-dot.is-attention { background: #d63638; }
.qbo-label {
  font-weight: 600;
}
.qbo-detail {
  color: #6c757d;
  min-width: 0;
  overflow-wrap: anywhere;
}
.qbo-retry {
  flex: 0 0 auto;
}
</style>
